class CommonCalculator {
	static arraySum(rows, toFix = true) {
		let result = 0;
		if (rows)
			result = rows.reduce((sum, row) => sum + parseFloat(row.amount || 0), 0);

		if (toFix) result.toFixed(2);

		return result;
	}
}

export default CommonCalculator;
